/**
 * Detects non-actionable Safari "Cannot call a class as a function" noise.
 *
 * Safari's JavaScriptCore engine throws this TypeError when a class
 * constructor is invoked without `new`. In practice, this surfaces as
 * stackless, unhandled errors on Safari (both desktop and mobile) across
 * many pages — likely caused by a browser-internal quirk or a transpiled
 * dependency interaction. The errors are not reproducible and carry no
 * actionable stack frames.
 *
 * Only suppressed when no meaningful stack frames are present.
 */
export const isSafariClassAsFunctionNoise = (
  message: string | undefined,
  stack: string | undefined,
): boolean => {
  if (message !== "Cannot call a class as a function") {
    return false;
  }

  if (!stack || stack === "TypeError: Cannot call a class as a function") {
    return true;
  }

  const frames = stack.split("\n").filter((l) => l.trim().startsWith("at "));
  return frames.length === 0;
};
